<template>
  <div id="account">
    <br>
    <el-card id="account-card">
      <div slot="header" class="clearfix">
        <span>{{$t('Mi cuenta')}}</span>
      </div>
      <el-form ref="form" :rules="rules" :model="user" label-width="200px">
        <el-form-item :label="$t('Nombre')">{{user.nombre}}</el-form-item>
        <el-form-item :label="$t('Apellido')">{{user.apellido}}</el-form-item>
        <el-form-item :label="$t('Rut')">{{user.rut}}</el-form-item>
        <el-form-item :label="$t('E-mail')" prop="email">
          <el-input type="email" v-model="user.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Contraseña')" prop="pass">
          <el-input type="password" v-model="user.pass"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Confirmar contraseña')" prop="passConfirm">
          <el-input type="password" v-model="passConfirm"></el-input>
        </el-form-item>
        <br>
        <el-form-item id="buttons">
          <el-button type="primary" :disabled="!updateEnabled" @click="updateUser">{{$t('Actualizar datos')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { clone, pick } from 'lodash'

export default {
  computed: {
    updateEnabled () {
      return (
        this.user.pass || this.user.email !== this.$store.state.user.user.email
      )
    }
  },
  data () {
    return {
      user: clone(this.$store.state.user.user),
      passConfirm: '',
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('Por favor, ingrese un email válido.'),
            trigger: 'blur'
          }
        ],
        pass: [
          {
            min: 6,
            message: this.$t('La contraseña debe tener al menos 6 caracteres.'),
            trigger: 'change'
          }
        ],
        passConfirm: [
          {
            validator: this.validatePass,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    validatePass (rule, value, callback) {
      if (!this.user.pass) {
        callback()
      }
      if (this.passConfirm !== this.user.pass) {
        callback(new Error(this.$t('Las contraseñas no coinciden.')))
      }
      callback()
    },
    updateUser () {
      const userUpdate = pick(this.user, ['email', 'pass'])

      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(userUpdate)
          this.$store
              .dispatch('editUser', {
                id: this.$store.state.user.user._id,
                body: userUpdate
              })
              .then(response => {
                if (response.success) {
                  this.$notify.success({
                    title: this.$t('Éxito'),
                    message: this.$t('Cuenta editada exitosamente')
                  })
                } else {
                  this.$alert(response.message, this.$t('Atención'), {
                    type: 'error'
                  })
                }
              })
        }
      })
    }
  }
}
</script>


<style scoped>
#account-card {
  width: 25%;
  margin: 0 auto;
  /* text-align: center; */
}
#buttons {
  float: right;
}
</style>

